import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import DateUtil from '../util/Util';

class PropertyController {

  static Staff = 'responsible_person';

  static NotCustomFields = ['id', 'status', 'created_by', 'updated_by', 'created_date', 'updated_date',
    'property_id', 'name', 'type', 'property_transaction', 'transaction_type', 'furnishing', 'property_status', 
    'property_age', 'parking_option', 'oc_received', 'property_type', 'reference', 'responsible_person', 'num_of_tower', 
    'wing', 'floor', 'of', 'available_date', 'rating', 'build_area', 'carpet_area', 'price_per_sqft', 'price', 
    'agreement_price', 'incentives', 'gst_percen', 'developement_charge_percen', 'developement_charge', 
    'parking_charges', 'society_charges', 'other_charges', 'registration', 'stamp_duty', 'total_price', 
    'property_code_99acres', 'amenities', 'total_bathroom', 'total_balconies', 'water_supply', 'neighbourhood', 
    'description', 'address', 'phone', 'email', 'facing', 'rent', 'deposit', 'area', 'possession_type', 'model', 
    'project', 'contact~name', 'contact~phone', 'contact~email'];

  static addModel = fields => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;

    let property ={};
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(!fields[keys[i]].editable) continue;
      const fieldType = fields[keys[i]].field_type;
      const val = fields[keys[i]].default_value;
      if(fieldType === Const.Date || fieldType === Const.DateTime) {
        property[keys[i]] = '';
        if(val === 'today') property[keys[i]] = DateUtil.dateToServerDateTime(new Date());
      } else if(fieldType === Const.Address) {
        property[keys[i]] = [];
      } else if(keys[i] === PropertyController.Staff) {
        property[keys[i]] = '~' + user + '~';
      } else if(fieldType.includes(Const.MultiSelect)) {
        property[keys[i]] = '';
        if(val) {
          property[keys[i]] = '~' + val.replace(',', '~') + '~';
        }
      } else {
        property[keys[i]] = val;
      }
    }
    property.status = Const.Active;
    property.property_status = 1;
    property.available_date = property.available_date 
      ? property.available_date : DateUtil.dateToServerDateTime(new Date());
    return property;
  }

  static getCustomFields = fields => {
    let customField = {};
    let keys = Object.keys(fields);
    const unknow = [];
    for(let i = 0; i < keys.length; i++) {
      const find = PropertyController.NotCustomFields.find(field => field === keys[i]);
      if(!find) {
        unknow.push(keys[i]);
        customField[keys[i]] = fields[keys[i]];
      }
    }
    return customField;
  }
}
export default PropertyController;